/*
 * FIBRA6 — Basis-Verhalten
 *
 * Bewegung Klasse B: Elemente mit [data-einblenden] erscheinen einmal,
 * wenn sie ins Bild kommen, und bleiben danach stehen. Kein Zurücksetzen
 * beim Hochscrollen — das wäre Bewegung ohne neue Information.
 *
 * Dazu kleine Verbesserungen, die ohne JavaScript einfach entfallen:
 * Menü (Esc, Tippen daneben), Werkbank-Pfeile für Maus/Trackpad,
 * Fotos blenden nach dem Laden weich ein statt hart aufzuspringen.
 */
(() => {
  const ruhig = matchMedia("(prefers-reduced-motion: reduce)");
  const hatBeobachter = "IntersectionObserver" in window;

  // ---------- Einblenden (Klasse B) ----------
  const einblender = hatBeobachter
    ? new IntersectionObserver(
        (eintraege) => {
          for (const eintrag of eintraege) {
            if (!eintrag.isIntersecting) continue;
            eintrag.target.classList.add("ist-sichtbar");
            einblender.unobserve(eintrag.target);
          }
        },
        { rootMargin: "0px 0px -12% 0px" },
      )
    : null;

  const erfasseEinblenden = (wurzel) => {
    for (const el of wurzel.querySelectorAll("[data-einblenden]:not(.ist-sichtbar)")) {
      if (einblender) einblender.observe(el);
      else el.classList.add("ist-sichtbar");
    }
  };

  // ---------- Fotos: erst zeigen, wenn sie geladen sind ----------
  // Das erste große Bild (fetchpriority=high) steht sofort, sonst litte der Seitenaufbau.
  const erfasseFotos = (wurzel) => {
    for (const bild of wurzel.querySelectorAll('img.foto__bild:not([fetchpriority="high"])')) {
      if (bild.complete) continue;
      bild.classList.add("laedt");
      const fertig = () => bild.classList.remove("laedt");
      bild.addEventListener("load", fertig, { once: true });
      bild.addEventListener("error", fertig, { once: true });
    }
  };

  // ---------- Werkbank: Pfeile für Maus und Trackpad ----------
  const erfasseWerkbaenke = (wurzel) => {
    for (const bank of wurzel.querySelectorAll("[data-werkbank]")) {
      if (bank.dataset.bereit) continue;
      bank.dataset.bereit = "1";

      const steuerung = bank.closest("section")?.querySelector("[data-werkbank-steuerung]");
      const karten = bank.children;
      if (!steuerung || karten.length < 2 || !hatBeobachter) continue;

      const [zurueck, vor] = steuerung.querySelectorAll("[data-werkbank-schritt]");
      const erste = karten[0];
      const letzte = karten[karten.length - 1];
      const ganz = new Map();

      steuerung.addEventListener("click", (e) => {
        const knopf = e.target.closest("[data-werkbank-schritt]");
        if (!knopf) return;
        const schritt = karten[1].offsetLeft - karten[0].offsetLeft;
        bank.scrollBy({
          left: Number(knopf.dataset.werkbankSchritt) * schritt,
          behavior: ruhig.matches ? "auto" : "smooth",
        });
      });

      // Randkarten ganz sichtbar = Ende erreicht. Kein Scroll-Listener.
      const rand = new IntersectionObserver(
        (eintraege) => {
          for (const e of eintraege) ganz.set(e.target, e.intersectionRatio > 0.9);
          zurueck.disabled = Boolean(ganz.get(erste));
          vor.disabled = Boolean(ganz.get(letzte));
          steuerung.hidden = zurueck.disabled && vor.disabled;
        },
        { root: bank, threshold: [0, 0.9, 1] },
      );
      rand.observe(erste);
      rand.observe(letzte);
    }
  };

  const erfasse = (wurzel) => {
    erfasseEinblenden(wurzel);
    erfasseFotos(wurzel);
    erfasseWerkbaenke(wurzel);
  };

  erfasse(document);

  // Theme-Editor lädt Sections einzeln neu: Neue Elemente müssen erfasst werden,
  // sonst bleiben sie unsichtbar.
  document.addEventListener("shopify:section:load", (e) => erfasse(e.target));

  // ---------- Warenkorb im Kopf ----------
  document.addEventListener("warenkorb:zahl", (e) => {
    const korb = document.querySelector("[data-korb]");
    const zahl = korb?.querySelector("[data-korb-zahl]");
    if (!korb || !zahl) return;
    zahl.textContent = e.detail;
    korb.hidden = !(e.detail > 0);
    korb.classList.remove("ist-neu");
    void korb.offsetWidth; // Animation neu starten
    korb.classList.add("ist-neu");
  });

  // ---------- Formulare, die sich bei Änderung selbst absenden (Warenkorb-Mengen) ----------
  document.addEventListener("change", (e) => {
    const feld = e.target.closest("[data-sofort-senden]");
    if (feld && feld.form) feld.form.requestSubmit ? feld.form.requestSubmit() : feld.form.submit();
  });

  // ---------- Menü ----------
  const offenesMenue = () => document.querySelector("details[data-menue][open]");

  const schliesse = (menue, fokus) => {
    menue.open = false;
    if (fokus) menue.querySelector("summary")?.focus();
  };

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const menue = offenesMenue();
    if (menue) schliesse(menue, true);
  });

  document.addEventListener("click", (e) => {
    const menue = offenesMenue();
    if (!menue) return;
    if (!menue.contains(e.target) || e.target.closest(".kopf__nav a")) schliesse(menue, false);
  });
})();
